<template>
  <v-card
    variant="outlined"
    class="relatorio-card"
    :class="{ 'dark-theme-relatorio': isDark }"
  >
    <!-- Header -->
    <div class="premium-header px-4 py-3">
      <v-row
        no-gutters
        align="center"
        class="flex-nowrap"
      >
        <div class="header-title">
          <v-icon
            color="grey-darken-3"
            class="mr-2"
          >
            assignment
          </v-icon>
          <span class="text-h6 font-weight-medium text-grey-darken-3">Relatório Médico</span>
        </div>
        
        <v-spacer />
        
        <!-- Busca de Modelos -->
        <v-autocomplete 
          v-model="modelo" 
          :items="modeloRelatorio.modelos"
          :loading="isLoading" 
          density="compact" 
          variant="outlined"
          item-title="nome" 
          item-value="_id"
          label="Buscar Modelos" 
          placeholder="Digite para buscar" 
          prepend-inner-icon="search" 
          return-object
          hide-details
          class="modelos-autocomplete"
          style="width: 280px;"
          @update:model-value="abrirDialogAplicarModelo"
        />

        <!-- Botões de Ação -->
        <div class="action-buttons d-flex align-center ml-4">
          <v-menu location="bottom">
            <template #activator="{ props }">
              <v-btn 
                v-bind="props"
                icon 
                variant="text" 
                class="action-btn"
              >
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>
            <v-list density="compact">
              <v-list-item
                :disabled="!idMedelo"
                @click="clear"
              >
                <template #prepend>
                  <v-icon>cleaning_services</v-icon>
                </template>
                <v-list-item-title>Limpar modelo</v-list-item-title>
              </v-list-item>
              <v-list-item
                :disabled="!!idMedelo || manualName.length < 8"
                @click="dialogNovoModelo = true"
              >
                <template #prepend>
                  <v-icon>note_add</v-icon>
                </template>
                <v-list-item-title>Novo modelo</v-list-item-title>
              </v-list-item>
              <v-list-item
                :disabled="!idMedelo || manualName.length < 8"
                @click="dialogEditarModelo = true"
              >
                <template #prepend>
                  <v-icon>edit</v-icon>
                </template>
                <v-list-item-title>Editar modelo</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-row>
    </div>

    <v-divider class="border-grey-lighten-2" />

    <!-- Conteúdo Principal -->
    <v-container
      fluid
      class="pa-4"
    >
      <!-- Editor -->
      <v-card
        variant="outlined"
        class="editor-card"
      >
        <v-card-title class="text-subtitle-1 font-weight-medium d-flex align-center text-grey-darken-3">
          <v-icon
            color="grey-darken-3"
            class="mr-2"
          >
            edit_note
          </v-icon>
          Editor de Relatório
        </v-card-title>
        <v-divider class="mx-4 mb-4 border-grey-lighten-2" />
        <v-card-text class="pa-0">
          <tiptap-editor 
            v-model="manualName" 
            :placeholder="'Descreva o relatório médico...'"
            :editable="true"
            class="editor-container"
            @update:modelValue="handleEditorUpdate"
          />
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog
      v-model="dialogAplicarModelo"
      width="420"
      persistent
    >
      <v-card class="rounded-lg" style="background-color: rgb(var(--v-theme-surface)); color: rgb(var(--v-theme-on-surface));">
        <v-card-title>Aplicar modelo</v-card-title>
        <v-card-text>
          Escolha como deseja inserir o modelo
          <strong>{{ modeloPendente?.nome || '' }}</strong>.
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn variant="text" @click="cancelarAplicacaoModelo">Cancelar</v-btn>
          <v-btn variant="outlined" @click="aplicarModelo('substituir')">Substituir</v-btn>
          <v-btn color="primary" variant="flat" @click="aplicarModelo('acrescentar')">Acrescentar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Diálogo para Novo Modelo -->
    <v-dialog
      v-model="dialogNovoModelo"
      width="900"
      persistent
    >
      <v-card class="rounded-lg gm-dialog">
        <v-card-title class="text-h5 gm-dialog-header py-3 d-flex align-center">
          <v-icon
            left
            color="grey-darken-2"
          >
            add_circle
          </v-icon>
          <span class="ml-2">Cadastrar Novo Modelo</span>
        </v-card-title>

        <v-card-text class="pa-6 gm-dialog-content">
          <v-text-field 
            v-model="tituloModelo"
            label="Título do Modelo" 
            variant="outlined"
            :rules="[v => !!v || 'Título é obrigatório']"
            color="grey-darken-3"
            density="compact"
            class="mb-4"
          />
          
          <v-card
            variant="outlined"
            class="editor-modelo-card"
          >
            <v-card-title class="text-subtitle-2 font-weight-medium d-flex align-center text-grey-darken-3 py-3">
              <v-icon
                color="grey-darken-3"
                size="small"
                class="mr-2"
              >
                description
              </v-icon>
              Conteúdo do Modelo
            </v-card-title>
            <v-divider class="border-grey-lighten-2" />
            <v-card-text class="pa-0">
              <tiptap-editor 
                v-model="contentModelo" 
                :placeholder="'Descrição do modelo...'"
                :editable="true"
                class="editor-container"
                @update:modelValue="handleModeloUpdate"
              />
            </v-card-text>
          </v-card>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4 gm-dialog-actions">
          <v-spacer />
          <v-btn 
            color="grey-darken-2" 
            variant="text" 
            class="action-btn"
            @click="dialogNovoModelo = false"
          >
            Cancelar
          </v-btn>
          <v-btn 
            color="primary"
            :loading="loadReceita" 
            class="action-btn" 
            variant="flat"
            :disabled="!tituloModelo || contentModelo.length < 8"
            @click="cadastrarModeloRelatorio"
          >
            <v-icon left>
              save
            </v-icon>
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para Editar Modelo -->
    <v-dialog
      v-model="dialogEditarModelo"
      width="900"
      persistent
    >
      <v-card class="rounded-lg gm-dialog">
        <v-card-title class="text-h5 gm-dialog-header py-3 d-flex align-center">
          <v-icon
            left
            color="grey-darken-2"
          >
            edit
          </v-icon>
          <span class="ml-2">Editar Modelo</span>
        </v-card-title>

        <v-card-text class="pa-6 gm-dialog-content">
          <v-text-field 
            v-model="tituloModelo"
            label="Título do Modelo" 
            variant="outlined"
            :rules="[v => !!v || 'Título é obrigatório']"
            color="grey-darken-3"
            density="compact"
            class="mb-4"
          />
          
          <v-card
            variant="outlined"
            class="editor-modelo-card"
          >
            <v-card-title class="text-subtitle-2 font-weight-medium d-flex align-center text-grey-darken-3 py-3">
              <v-icon
                color="grey-darken-3"
                size="small"
                class="mr-2"
              >
                description
              </v-icon>
              Conteúdo do Modelo
            </v-card-title>
            <v-divider class="border-grey-lighten-2" />
            <v-card-text class="pa-0">
              <tiptap-editor 
                v-model="contentModelo" 
                :placeholder="'Descrição do modelo...'"
                :editable="true"
                class="editor-container"
                @update:modelValue="handleModeloUpdate"
              />
            </v-card-text>
          </v-card>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4 gm-dialog-actions">
          <v-spacer />
          <v-btn 
            color="grey-darken-2" 
            variant="text" 
            class="action-btn"
            @click="dialogEditarModelo = false"
          >
            Cancelar
          </v-btn>
          <v-btn 
            color="primary"
            class="action-btn" 
            variant="flat"
            :disabled="!tituloModelo || contentModelo.length < 8"
            @click="cadastrarModeloRelatorio"
          >
            <v-icon left>
              save
            </v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { ref, watch, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import medicoService from '../../../services/medico.service'
import tiptapEditor from './tiptapEditor.vue'

export default {
  name: 'EditorRelatorioAtendimento',
  
  components: { 
    'tiptap-editor': tiptapEditor 
  },
  
  props: {
    paciente: {
      type: Object
    },
    relatorio: {
      type: Object
    }
  },
  
  emits: ['voltar', 'relatorioAtendimento'],
  
  setup(props, { emit }) {
    const store = useStore()
    const isDark = computed(() => store.getters.isDark);
    
    // Refs reativas
    const manualName = ref('')
    const contentModelo = ref('')
    const tituloModelo = ref('')
    const dialogNovoModelo = ref(false)
    const dialogEditarModelo = ref(false)
    const dialogAplicarModelo = ref(false)
    const loadRelatorio = ref(false)
    const idMedelo = ref(null)
    const isLoading = ref(false)
    const modeloRelatorio = ref({ modelos: [] })
    const modelo = ref(null)
    const modeloAtivo = ref(null)
    const modeloPendente = ref(null)
    const loadReceita = ref(false)
    const loadSalvar = ref(false)
    const relatorioExistente = ref(null)
    const user = ref(null)
    const campoRelatorioTemConteudo = (conteudo = manualName.value) => {
      const texto = (conteudo || '')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, '')
        .trim()
      return texto.length > 0
    }

    // Métodos
    const abrirDialogAplicarModelo = (valor) => {
      if (!valor) return
      modeloPendente.value = valor
      if (!campoRelatorioTemConteudo()) {
        aplicarModelo('substituir')
      } else {
        dialogAplicarModelo.value = true
        modelo.value = null
      }
    }

    const aplicarModelo = (modo = 'acrescentar') => {
      if (!modeloPendente.value) return
      const item = modeloPendente.value
      tituloModelo.value = item.nome
      idMedelo.value = item._id
      modeloAtivo.value = item
      manualName.value = modo === 'substituir'
        ? item.descricao
        : (manualName.value ? `${manualName.value}<p></p>${item.descricao}` : item.descricao)
      cancelarAplicacaoModelo()
    }

    const cancelarAplicacaoModelo = () => {
      dialogAplicarModelo.value = false
      modeloPendente.value = null
      modelo.value = null
    }

    const clear = () => {
      manualName.value = ''
      modelo.value = null
      modeloAtivo.value = null
      tituloModelo.value = ''
      idMedelo.value = null
    }

    const cadastrarModeloRelatorio = () => {
      loadReceita.value = true
      const modeloRelatorioData = {
        idUsuario: user.value.id,
        nome: tituloModelo.value,
        descricao: contentModelo.value,
        _id: dialogEditarModelo.value ? idMedelo.value : null
      }

      medicoService.medico.cadastrarModeloRelatorio(modeloRelatorioData)
        .then(() => {
          dialogNovoModelo.value = false
          dialogEditarModelo.value = false
          idMedelo.value = null
          contentModelo.value = ''
          buscarModeloRelatorio()
        })
        .catch(error => {
          console.error('Erro ao cadastrar modelo:', error)
        })
        .finally(() => {
          loadReceita.value = false
        })
    }

    const buscarModeloRelatorio = () => {
      isLoading.value = true
      medicoService.medico.buscarModeloRelatorio(user.value.id)
        .then((r) => {
          if (r.status === 200) {
            modeloRelatorio.value = r.data
          }
        })
        .catch(error => {
          console.error('Erro ao buscar modelos:', error)
        })
        .finally(() => {
          isLoading.value = false
        })
    }

    const buscarRelatorioExistente = () => {
      if (props.relatorio && props.relatorio.id) {
        loadRelatorio.value = true
        medicoService.medico.buscarRelatorioPorId(props.relatorio.id)
          .then((r) => {
            if (r.status === 200 && r.data && r.data.length > 0) {
              relatorioExistente.value = r.data[0]
              manualName.value = relatorioExistente.value.descricao || ''
            }
          })
          .catch(error => {
            console.error('Erro ao buscar relatório existente:', error)
          })
          .finally(() => {
            loadRelatorio.value = false
          })
      }
    }

    const salvar = () => {
      loadSalvar.value = true

      const dadosRelatorio = {
        idAtendimento: props.paciente.idAtendimento,
        idMedico: user.value?.id,
        descricao: manualName.value,
        idRelatorio: props.relatorio && props.relatorio.id
      }

      const operacao = (props.relatorio && props.relatorio.id)
        ? medicoService.medico.atualizarRelatorio(dadosRelatorio)
        : medicoService.medico.cadastrarRelatorio(dadosRelatorio)

      operacao
        .then(() => {
          emit('voltar')
        })
        .catch(error => {
          console.error('Erro ao salvar relatório:', error)
        })
        .finally(() => { 
          loadSalvar.value = false 
        })
    }

    const handleEditorUpdate = (value) => {
      manualName.value = value
      emit('relatorioAtendimento', value)
    }

    const handleModeloUpdate = (value) => {
      contentModelo.value = value
    }

    const voltar = () => {
      emit('voltar')
    }

    // Watchers
    watch(manualName, (val) => {
      emit('relatorioAtendimento', val)
    })

    watch(() => props.relatorio, (val) => {
      if (val != null) {
        manualName.value = val.descricao || ''
      } else {
        manualName.value = ''
      }
    }, { immediate: true })

    watch(dialogNovoModelo, (val) => {
      if (val) {
        contentModelo.value = manualName.value
        tituloModelo.value = ''
        idMedelo.value = null
        modelo.value = null
      }
    })

    watch(dialogEditarModelo, (val) => {
      const modeloEdicao = modeloAtivo.value || modelo.value
      if (val && modeloEdicao) {
        contentModelo.value = modeloEdicao.descricao
        tituloModelo.value = modeloEdicao.nome
      }
    })

    // Lifecycle
    onMounted(() => {
      user.value = store.getters.usuario
      buscarModeloRelatorio()
      
      // Inicializa o conteúdo se houver um relatório passado como prop
      if (props.relatorio && props.relatorio.descricao) {
        manualName.value = props.relatorio.descricao
      }
    })

    return {
      // Refs
      manualName,
      contentModelo,
      tituloModelo,
      dialogNovoModelo,
      dialogEditarModelo,
      dialogAplicarModelo,
      loadRelatorio,
      idMedelo,
      isLoading,
      modeloRelatorio,
      modelo,
      modeloAtivo,
      modeloPendente,
      loadReceita,
      loadSalvar,
      relatorioExistente,
      user,
      isDark,
      
      // Métodos
      aplicarModelo,
      abrirDialogAplicarModelo,
      cancelarAplicacaoModelo,
      clear,
      cadastrarModeloRelatorio,
      buscarModeloRelatorio,
      buscarRelatorioExistente,
      salvar,
      handleEditorUpdate,
      handleModeloUpdate,
      voltar
    }
  }
}
</script>

<style scoped>
.relatorio-card {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
}

/* Header */
.premium-header {
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  min-height: 70px;
}

.header-title {
  display: flex;
  align-items: center;
}

.header-controls {
  gap: 12px;
}

.modelos-autocomplete {
  min-width: 280px;
}

.action-buttons {
  gap: 8px;
}

.action-btn {
  transition: all 0.3s ease;
}

.action-btn:hover {
  transform: translateY(-1px);
}

/* Cards de conteúdo */
.editor-card,
.editor-modelo-card {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  transition: box-shadow 0.3s ease;
}

.editor-card:hover,
.editor-modelo-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.editor-container {
  max-height: 470px;
  min-height: 420px;
  border-radius: 8px;
  overflow-y: auto;
}

/* Estado vazio */
.empty-state {
  border: 2px dashed rgba(var(--v-theme-on-surface), 0.12);
}

/* Actions Footer */
.actions-footer {
  border-top: 1px solid rgba(var(--v-theme-on-surface), 0.12);
}

/* Responsividade */
@media (max-width: 960px) {
  .premium-header {
    min-height: 60px;
    padding: 8px 12px;
  }
  
  .header-controls {
    flex-direction: column;
    gap: 8px;
  }
  
  .modelos-autocomplete {
    width: 100%;
    min-width: auto;
  }
  
  .action-buttons {
    justify-content: flex-end;
  }
}

@media (max-width: 600px) {
  .premium-header {
    min-height: 56px;
    padding: 6px 8px;
  }
  
  .actions-footer {
    flex-direction: column;
    gap: 12px;
  }
  
  .action-btn {
    width: 100%;
  }
}

/* Animações suaves */
.v-card {
  transition: all 0.3s ease;
}

.v-btn {
  transition: all 0.2s ease;
}

/* Scrollbar personalizada */
.editor-container :deep(.ProseMirror) {
  scrollbar-width: thin;
  scrollbar-color: rgba(var(--v-theme-on-surface), 0.2) transparent;
}

.editor-container :deep(.ProseMirror)::-webkit-scrollbar {
  width: 6px;
}

.editor-container :deep(.ProseMirror)::-webkit-scrollbar-track {
  background: transparent;
}

.editor-container :deep(.ProseMirror)::-webkit-scrollbar-thumb {
  background: rgba(var(--v-theme-on-surface), 0.2);
  border-radius: 3px;
}

.editor-container :deep(.ProseMirror)::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-theme-on-surface), 0.4);
}

.dark-theme-relatorio .editor-container :deep(.embedded-editor-container) {
    background-color: rgb(var(--v-theme-surface)) !important;
    border-color: rgba(var(--v-theme-on-surface), 0.12) !important;
}
.dark-theme-relatorio .editor-container :deep(.editor-content-wrapper),
.dark-theme-relatorio .editor-container :deep(.compact-editor-content) {
    background-color: rgb(var(--v-theme-surface)) !important;
    color: rgb(var(--v-theme-on-surface)) !important;
}
.dark-theme-relatorio .editor-container :deep(.ProseMirror) {
    color: rgb(var(--v-theme-on-surface)) !important;
}
.dark-theme-relatorio .editor-container :deep(.ProseMirror p),
.dark-theme-relatorio .editor-container :deep(.ProseMirror ul li),
.dark-theme-relatorio .editor-container :deep(.ProseMirror ol li),
.dark-theme-relatorio .editor-container :deep(.ProseMirror strong),
.dark-theme-relatorio .editor-container :deep(.ProseMirror em),
.dark-theme-relatorio .editor-container :deep(.ProseMirror u),
.dark-theme-relatorio .editor-container :deep(.ProseMirror s),
.dark-theme-relatorio .editor-container :deep(.ProseMirror h1),
.dark-theme-relatorio .editor-container :deep(.ProseMirror h2),
.dark-theme-relatorio .editor-container :deep(.ProseMirror h3) {
    color: rgb(var(--v-theme-on-surface)) !important;
}

.dark-theme-relatorio .editor-container :deep(.ProseMirror .is-empty:before) {
  color: rgba(var(--v-theme-on-surface), 0.5) !important;
}
</style>
